export function generateRangeArray(startValueNum, endValueNum) {
  if (startValueNum > endValueNum) return [];
  return Array.apply(null, Array(endValueNum - startValueNum + 1)).map((_, index) => {
    return startValueNum + index;
  });
}